// extracted by mini-css-extract-plugin
export default {"menu":"basicMenu_menu__PI3tl","menuList":"basicMenu_menuList__Oo5EX","menuItem":"basicMenu_menuItem__Ezoc9","link":"basicMenu_link__s9Ta4"};